import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iframeOnly", "source"];
// @ts-expect-error no declarations found for module
import { dispatchActionInParent } from 'LayoutBuilderUI/actions/ApiActions';
import { UPDATE_RSS_SETTING, UPDATE_COLLABORATION_SIDEBAR_STATE } from 'ContentEditorUI/redux/actions/actionTypes';
import { FETCH_RSS_URL_FEED_VALIDATION_SUCCESS, FETCH_RSS_URL_FEED_VALIDATION_START, FETCH_RSS_URL_FEED_VALIDATION_FAIL } from 'EmailData/actions/actionTypes';
import { FETCH_BLOGS_SUCCEEDED, TOGGLE_BRANDING_PQL } from 'EmailEditorUI/redux/actions/actionTypes';
import { MODULE_REDUCER_CHANGE_UNDO, MODULE_REDUCER_CHANGE_REDO, OPEN_MODAL, UPDATE_CONTENT_MODEL_AI_FEATURES } from 'ContentEditorUI/redux/actions/actionTypes';
import { IFRAME_SYNCED_PREFIX } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { ACTION_TYPE_PREFIX as TINYMCE_ACTION_TYPE_PREFIX } from 'tinymce-plugins/actions/ActionTypes';
import { ACTION_TYPE_PREFIX as SMART_ACTION_TYPE_PREFIX } from 'smart-content-core/actions/ActionTypes';
import { ACTION_TYPE_PREFIX as BASE_INPAGE_TYPE_PREFIX } from 'ContentEditorUI/redux/actions/inpageReduxActionTypes';

// these action will be not dispatched in LBUI but on the parent
const IN_PAGE_ACTIONS = [UPDATE_RSS_SETTING, FETCH_RSS_URL_FEED_VALIDATION_SUCCESS, FETCH_RSS_URL_FEED_VALIDATION_START, FETCH_RSS_URL_FEED_VALIDATION_FAIL, FETCH_BLOGS_SUCCEEDED, TOGGLE_BRANDING_PQL, OPEN_MODAL, MODULE_REDUCER_CHANGE_UNDO, MODULE_REDUCER_CHANGE_REDO, UPDATE_COLLABORATION_SIDEBAR_STATE, UPDATE_CONTENT_MODEL_AI_FEATURES];
const postMessageMiddleware = () => next => _ref => {
  let {
      iframeOnly = true,
      source = 'iframe'
    } = _ref,
    action = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isInpageActionFromIFrame = source !== 'app' && !iframeOnly && (action.type.indexOf(TINYMCE_ACTION_TYPE_PREFIX) === 0 || action.type.indexOf(SMART_ACTION_TYPE_PREFIX) === 0 || action.type.indexOf(BASE_INPAGE_TYPE_PREFIX) === 0);
  const shouldDispatchInBoth = isInpageActionFromIFrame || action.type.startsWith(IFRAME_SYNCED_PREFIX);
  if (shouldDispatchInBoth || IN_PAGE_ACTIONS.includes(action.type)) {
    setTimeout(() => {
      dispatchActionInParent(action);
    }, 0);
    return shouldDispatchInBoth ? next(action) : null;
  }
  return next(action);
};
export default postMessageMiddleware;